import moment from 'moment';

/**
 * Parse a date without Moment's js Date() fallback, which warns on invalid strings.
 *
 * @param {unknown} value ISO string, Date, moment, or epoch millis.
 * @returns {moment.Moment|null}
 */
export function parseMoment(value) {
    if (value == null || value === '')
        return null;
    if (moment.isMoment(value))
        return value.isValid() ? value : null;
    if (value instanceof Date) {
        if (Number.isNaN(value.getTime()))
            return null;
        const parsed = moment(value);
        return parsed.isValid() ? parsed : null;
    }
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            return null;
        const parsed = moment(value);
        return parsed.isValid() ? parsed : null;
    }
    if (typeof value !== 'string')
        return null;

    const trimmed = value.trim();
    if (!trimmed)
        return null;

    const parsed = moment(trimmed, moment.ISO_8601, true);
    return parsed.isValid() ? parsed : null;
}
